import { classNames } from "src/helpers/classNames";

const Badge = ({ label, className = "", dot = null }) => (
  <span className={classNames("inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold", className)}>
    {dot && <span className={classNames("h-2 w-2 rounded-full", dot)} />}
    {label}
  </span>
);

export default Badge;
